export default __webpack_public_path__ + "static/media/prices.06c246e2.svg";